import { render, staticRenderFns } from "./BagModal.vue?vue&type=template&id=9055998a&scoped=true"
import script from "./BagModal.vue?vue&type=script&lang=js"
export * from "./BagModal.vue?vue&type=script&lang=js"
import style0 from "./BagModal.vue?vue&type=style&index=0&id=9055998a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9055998a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9055998a')) {
      api.createRecord('9055998a', component.options)
    } else {
      api.reload('9055998a', component.options)
    }
    module.hot.accept("./BagModal.vue?vue&type=template&id=9055998a&scoped=true", function () {
      api.rerender('9055998a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/commands/BagModal.vue"
export default component.exports